import React from 'react';
import TextCropper from '@omilia/text-cropper';
import Highlighter from 'react-highlight-words';

interface Props {
  text: string;
  match: string;
}

const Text = ({ text = '', match }: Props) => (
  <TextCropper text={text}>
    <Highlighter
      autoEscape
      highlightStyle={{
        backgroundColor: 'transparent',
        fontWeight: 500,
      }}
      searchWords={[match]}
      textToHighlight={text}
    />
  </TextCropper>
);

export default Text;
